import { isProduction } from '../environment';
import { XeroApi as RealXeroApi } from './xero-api';
import { XeroApi as MockXeroApi } from './mock-xero-api';

const SelectedXeroApi = isProduction() ? RealXeroApi : MockXeroApi;

export default SelectedXeroApi;